import { RESTError } from "../core/RESTError";

/**
 * An error that occurs while logging in a user, which has no token yet (data inconsistency).
 */
export class TokenNotFoundError extends RESTError {}
